import styled from "styled-components";
import Box from "../box";
export const Flex = styled(Box).withConfig({
  displayName: "flex__Flex",
  componentId: "sc-7r38zk-0"
})(["display:", ";"], p => p.inline ? "inline-flex" : "flex");
export default Flex;